import { logWrapper } from '../utils';

export default {
  groupModel: [
    'runtimeConstant',
    function (runtimeConstant) {
      function Group(data) {
        this.id = data ? data.Id : 0;
        this.name = data ? data.Name : '';
        this.users = [];
        this.foldersRoles = [];

        if (
          data &&
          data.Users &&
          Array.isArray(data.Users) &&
          data.Users.length > 0
        ) {
          var first = data.Users[0];

          // Verifica se ta retornando um User ou um UserGroup

          if (first.Id) {
            for (var i = 0; i < data.Users.length; i++) {
              this.users.push({
                id: data.Users[i].Id,
                name: data.Users[i].Name,
                email: data.Users[i].Email,
              });
            }
          } else {
            this.users = data.Users;
          }
        }
        if (
          data &&
          data.GroupsUsers &&
          Array.isArray(data.GroupsUsers) &&
          data.GroupsUsers.length > 0
        ) {
          var first = data.GroupsUsers[0];

          // Verifica se ta retornando um User ou um UserGroup

          if (first.Email) {
            for (var i = 0; i < data.GroupsUsers.length; i++) {
              this.users.push({
                id: data.GroupsUsers[i].User.Id,
                name: data.GroupsUsers[i].User.Name,
                email: data.GroupsUsers[i].User.Email,
              });
            }
          } else {
            this.users = data.GroupsUsers;
          }
        }
        this.selected = false;

        this._allRoles = false;
      }

      function title() {
        return this.name;
      }

      function details() {
        return '';
      }

      function tags() {
        return this.users.map(function (i) {
          return i.name;
        });
      }

      function anyUserSelected() {
        return this.allUsers.some(function (e) {
          return e.selected === true;
        });
      }

      function isValid() {
        return this.name;
      }

      function toggleAllRoles(value) {
        var that = this;
        if (arguments.length > 0) {
          if (!this.roles) {
            return;
          }

          this.roles.forEach(function (r) {
            if (
              !Array.isArray(that.selectedFolders) ||
              that.selectedFolders.length === 0
            ) {
              return;
            }

            that.selectedFolders.forEach(function (f) {
              if (value) {
                if (!Array.isArray(f.permissions)) {
                  f.permissions = [];
                }

                if (f.permissions.indexOf(r.id) === -1) {
                  f.permissions.push(r.id);
                }
              } else if (
                !value &&
                Array.isArray(f.permissions) &&
                f.permissions.indexOf(r.id) > -1
              ) {
                f.permissions.splice(f.permissions.indexOf(r.id), 1);
              }
            });
          });
        } else {
          if (
            !this.roles ||
            !Array.isArray(this.selectedFolders) ||
            this.selectedFolders.length === 0
          ) {
            return false;
          }

          return this.roles.every(function (r) {
            return that.selectedFolders.every(function (f) {
              return (
                Array.isArray(f.permissions) && f.permissions.indexOf(r.id) > -1
              );
            });
          });
        }
      }

      function clearFolderSelection() {
        if (Array.isArray(this.folders)) {
          for (var i = 0, len = this.folders.length; i < len; i++) {
            this.folders[i].recursiveSelect(false);
            this.folders[i].isOpen = false;
          }
          this.updateSelectedFolders();
        }
      }

      function updateSelectedFolders() {
        var selectedFolders = [];

        var recursiveSelected = function (folder) {
          if (Array.isArray(folder.children) && folder.children.length > 0) {
            for (var j = 0, length = folder.children.length; j < length; j++) {
              var child = folder.children[j];
              if (child.selected()) {
                selectedFolders.push(child);
              }
              recursiveSelected(child);
            }
          }
        };

        for (var i = 0, len = this.folders.length; i < len; i++) {
          var folder = this.folders[i];
          if (folder.selected()) {
            selectedFolders.push(folder);
          }

          recursiveSelected(folder);
        }
        this.selectedFolders = selectedFolders;
      }

      function updateSelectedRoles() {
        var selectedFoldersRoles = [];
        var that = this;
        var recursiveSelected = function (folder) {
          if (Array.isArray(folder.children) && folder.children.length > 0) {
            for (var j = 0, length = folder.children.length; j < length; j++) {
              var child = folder.children[j];
              if (child.selected()) {
                var l = that.permissions.filter(function (p) {
                  return p.folder === child.id;
                })[0];
                if (l) {
                  selectedFoldersRoles.push(l);
                }
              }

              recursiveSelected(child);
            }
          }
        };

        if (Array.isArray(this.permissions) && this.permissions.length > 0) {
          for (var i = 0, len = this.folders.length; i < len; i++) {
            var folder = this.folders[i];
            if (folder.selected()) {
              var p = this.permissions.filter(function (p) {
                return p.folder === folder.id;
              })[0];
              if (p) {
                selectedFoldersRoles.push(p);
              }
            }

            recursiveSelected(folder);
          }
        }

        this.foldersRoles = this.roles.map(function (r) {
          var anySelected = selectedFoldersRoles.some(function (fr) {
            return fr.roles.indexOf(r.id) !== -1;
          });
          var isSelected = anySelected
            ? selectedFoldersRoles.every(function (fr) {
                return fr.roles.indexOf(r.id) !== -1;
              })
              ? true
              : null
            : false;

          return {
            id: r.id,
            name: r.name,
            selected: isSelected,
          };
        });
      }

      function toggleAllUsers(value) {
        if (arguments.length > 0) {
          this.allUsers.forEach(function (d) {
            d.selected = value;
          });
        } else {
          if (this.allUsers === undefined || this.allUsers === null) {
            return false;
          }

          return this.allUsers.every(function (d) {
            return d.selected === true;
          });
        }
      }

      function run() {
        try {
          Group.prototype = {
            title: logWrapper(title, runtimeConstant.isDebugModelsInternals),
            details: logWrapper(
              details,
              runtimeConstant.isDebugModelsInternals
            ),
            tags: logWrapper(tags, runtimeConstant.isDebugModelsInternals),
            anyUserSelected: logWrapper(
              anyUserSelected,
              runtimeConstant.isDebugModelsInternals
            ),
            isValid: logWrapper(
              isValid,
              runtimeConstant.isDebugModelsInternals
            ),
            toggleAllRoles: logWrapper(
              toggleAllRoles,
              runtimeConstant.isDebugModelsInternals
            ),
            clearFolderSelection: logWrapper(
              clearFolderSelection,
              runtimeConstant.isDebugModelsInternals
            ),
            updateSelectedFolders: logWrapper(
              updateSelectedFolders,
              runtimeConstant.isDebugModelsInternals
            ),
            updateSelectedRoles: logWrapper(
              updateSelectedRoles,
              runtimeConstant.isDebugModelsInternals
            ),
            toggleAllUsers: logWrapper(
              toggleAllUsers,
              runtimeConstant.isDebugModelsInternals
            ),
          };

          return Group;
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error(error);
        }
      }

      // Wrap the setup function with logWrapper for debugging purposes
      return logWrapper(run, runtimeConstant.isDebugModels)();
    },
  ],
};
